/**
 * Resize any images with Cloudflare workers
 *
 * @param {string} url - source url
 * @param {number} width - Specifies maximum width of the image in pixels.
 * @param {number} quality - Specifies quality for images in JPEG, WebP, and AVIF formats. The quality is in a 1-100 scale, but useful values are between 50 (low quality, small file size) and 90 (high quality, large file size). 85 is the default.
 * @param {string} fit - Affects interpretation of width and height. All resizing modes preserve aspect ratio.
 * @returns {string} resized url
 */
export const resizeImage = (url, width = 512, quality = 100, fit = 'scale-down') => {
  // if (!url) {
  //   return ''
  // }
  // const instance = new URL(url)
  // if (!/cdn(-dev)?\.istaging\.com/.test(url)) {
  //   instance.protocol = 'https:'
  //   instance.host = 'resize-anywhere.istaging.com'
  //   instance.pathname = ''
  //   instance.searchParams.set('image', url)
  // }
  // instance.searchParams.set('w', width)
  // instance.searchParams.set('q', quality)
  // instance.searchParams.set('fit', fit)
  // return instance.href
  return url
}

/**
 * Resize images host on iStaging CDN with Cloudflare workers
 *
 * @param {string} url - source url
 * @param {number} width - Specifies maximum width of the image in pixels.
 * @param {number} quality - Specifies quality for images in JPEG, WebP, and AVIF formats. The quality is in a 1-100 scale, but useful values are between 50 (low quality, small file size) and 90 (high quality, large file size). 85 is the default.
 * @param {string} fit - Affects interpretation of width and height. All resizing modes preserve aspect ratio.
 * @returns {string} resized url
 */
export const resizeCDNImage = (url = '', width, quality = 80, fit = 'scale-down') => {
  if (!url) {
    return ''
  }
  const instance = new URL(url)
  instance.searchParams.set('w', width)
  instance.searchParams.set('q', quality)
  instance.searchParams.set('fit', fit)
  return instance.href
}
